import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import UploadImage from '@/components/upload-image/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';

import PublishProjectService from '../publish-project-service.js';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    UploadImage,
    ProcessNavigation
  },
  data() {
    return {
      step: 4,
      id: '',
      oldId: '',
      isCreated: true,
      projectInfo: {},
      form: {
        files: []
      },
      projectType: 1, // 项目类型
      projectSubType: 1 // 项目子类
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'processList',
      'tradeType'
    ])
  },
  created () {
    window.scrollTo(0, 0);
    this.projectType = this.$route.query.projectType; // 项目类型
    this.projectSubType = this.$route.query.projectSubType; // 项目子类
    if (this.tradeType === '2') {
      this.step = 2;
    }
    this.initFiles();
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    if (this.id) {
      this.getNewAttachmentInfo().then(() => {}, () => {
        if (this.oldId) {
          this.getOldAttachmentInfo();
        }
      });
      this.getProjectInfo();
    }
  },
  methods: {
    initFiles () {
      console.log(this.userInfo);
      if(Number(this.$route.query.projectType) === 1 && Number(this.$route.query.projectSubType) === 2 ) {
        if(this.userInfo.type === 1 || this.userInfo.type === 3){
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '土地承包经营权证等权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 5, title: '转让方身份证等主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 19, title: '共有权人同意交易的证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 6, title: '原承包方同意再次交易的书面意见（再流转）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 7, title: '原流转交易合同（再流转）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 8, title: '备案材料（再流转）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        } else {
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '土地承包经营权证等权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 5, title: '转让方身份证等主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 19, title: '共有权人同意交易的证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 6, title: '原承包方同意再次交易的书面意见（再流转）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 7, title: '原流转交易合同（再流转）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 8, title: '备案材料（再流转）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        }
      } else if(Number(this.$route.query.projectType) === 2) {
        this.form.files = [
          {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 2, title: '发包方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 5, title: '转让方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 6, title: '原发包方同意再次交易的书面意见（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 7, title: '原流转交易合同（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 8, title: '登记备案材料（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
        ];
        if(Number(this.$route.query.projectSubType) === 3) {
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 2, title: '转让方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 3, title: '乡镇政府等有关批准文件', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 5, title: '转让方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        }
        // 如果不是法人 删除授权委托书
        if(this.userInfo.type !== 2) {
          let index = this.form.files.findIndex(item => item.projectFileType === 14);
          this.form.files.splice(index, 1);
        }
      } else if(Number(this.$route.query.projectType) === 6 && Number(this.$route.query.projectSubType) === 1) {
        if(this.userInfo.type === 1 || this.userInfo.type === 3){
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 12, title: '出租方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 13, title: '出租方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 15, title: '所有权人同意转租的书面意见（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 16, title: '原租赁合同（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 17, title: '登记备案材料（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 10, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        } else {
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 12, title: '出租方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 13, title: '出租方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 15, title: '所有权人同意转租的书面意见（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 16, title: '原租赁合同（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 17, title: '登记备案材料（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 10, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        }
      } else if(Number(this.$route.query.projectType) === 7 && Number(this.$route.query.projectSubType) === 1 ) {
        if(this.userInfo.type === 1 || this.userInfo.type === 3) {
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 18, title: '转让方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 5, title: '转让方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 10, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        } else {
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 18, title: '转让方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 5, title: '转让方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 10, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        }
      } else if(Number(this.$route.query.projectType) === 7 && Number(this.$route.query.projectSubType) === 2) {
        if(this.userInfo.type === 1 || this.userInfo.type === 3) {
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 2, title: '出租方案的民主决策证明', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 13, title: '出租方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            // {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 6, title: '原发包方同意再次交易的书面证明（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 16, title: '原交易公告合同（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 17, title: '登记备案材料（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        } else {
          this.form.files = [
            {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 2, title: '出租方案的民主决策证明', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 13, title: '出租方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 6, title: '原发包方同意再次交易的书面证明（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 16, title: '原交易公告合同（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 17, title: '登记备案材料（转租）', filePaths: [], defaultImage: [], inputValue: null},
            {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
          ];
        }
      } else if((Number(this.$route.query.projectType) === 1 && Number(this.$route.query.projectSubType) === 1) || (Number(this.$route.query.projectType) === 4)) {
        this.form.files = [
          {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 2, title: '发包方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 5, title: '转让方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 6, title: '原发包方同意再次交易的书面意见（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 7, title: '原流转交易合同（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 8, title: '登记备案材料（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
        ];
      }else {
        this.form.files = [
          {projectFileType: 1, title: '项目照片', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 2, title: '发包方案的民主决策决议', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 3, title: '主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
          // {projectFileType: 3, title: '民主决策和主管部门批准文件', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 4, title: '权属证明材料', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 5, title: '转让方主体资格证明材料', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 14, title: '授权委托书', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 6, title: '原发包方同意再次交易的书面意见（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 7, title: '原流转交易合同（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 8, title: '登记备案材料（再流转）', filePaths: [], defaultImage: [], inputValue: null},
          {projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null}
        ];

        // 如果不是法人 删除授权委托书
        if(this.userInfo.type !== 2) {
          let index = this.form.files.findIndex(item => item.projectFileType === 14);
          this.form.files.splice(index, 1);
        }
      }
    },
    getNewAttachmentInfo () {
      return new Promise((resolve, reject) => {
        PublishProjectService.getProjectInfo({
          projectId: this.id,
          echoCode: 'FILE'
        }).then(res => {
          if (!res.data) {
            reject();
          } else {
            this.isCreated = false;
            res.data && res.data.files.forEach(item => {
              const index = this.form.files.findIndex(file => file.projectFileType === item.projectFileType);
              item.filePaths.forEach(image => {
                this.form.files[index].defaultImage.push({
                  url: image.allPath,
                  ossImgUrl: image.allPath,
                  sourceImgUrl: image.fullPath
                });
                this.form.files[index].filePaths.push({
                  ossImgUrl: image.allPath,
                  sourceImgUrl: image.fullPath
                });
                this.form.files[index].inputValue = this.form.files[index].filePaths.length;
              });
            });
            resolve();
          }
        });
      });
    },
    getOldAttachmentInfo () {
      PublishProjectService.getProjectInfo({
        projectId: this.oldId,
        echoCode: 'FILE'
      }).then(res => {
        if (!res.data) {
          return;
        }
        this.isCreated = true;
        res.data && res.data.files.forEach(item => {
          const index = this.form.files.findIndex(file => file.projectFileType === item.projectFileType);
          item.filePaths.forEach(image => {
            this.form.files[index].defaultImage.push({
              url: image.allPath,
              ossImgUrl: image.allPath,
              sourceImgUrl: image.fullPath
            });
            this.form.files[index].filePaths.push({
              ossImgUrl: image.allPath,
              sourceImgUrl: image.fullPath
            });
            this.form.files[index].inputValue = this.form.files[index].filePaths.length;
          });
        });
      });
    },
    getProjectInfo () {
      PublishProjectService.getProjectInfo({
        projectId: this.id,
        echoCode: 'PROJECT'
      }).then(res => {
        this.projectInfo = res.data;
      });
    },
    fileRules (item) {
      let required = true;
      if (item.projectFileType === 9) {
        required = false;
      }
      if (item.projectFileType === 10) {
        required = false;
      }
      if (item.projectFileType === 15 || item.projectFileType === 16 || item.projectFileType === 17 || item.projectFileType === 6 || item.projectFileType === 7 || item.projectFileType === 8) {
        required = false;
        if (this.projectInfo.circulationTypeCode === 3) {
          required = true;
        }
      }
      if(Number(this.userInfo.type) === 1 || Number(this.userInfo.type) === 2 ){
        if(Number(this.$route.query.projectType) === 1  && Number(this.$route.query.projectSubType) === 1){
          if (item.projectFileType === 6) {
            required = true;
          }
        }
      }
      // if((Number(this.$route.query.projectType) === 6 || Number(this.$route.query.projectType) === 7) && Number(this.$route.query.projectSubType) === 1 ){
      //   if (item.projectFileType === 6) {
      //     required = true;
      //   }
      // }
      return {
        required: required,
        message: '请上传' + item.title,
        trigger: 'change'
      };
    },
    uploadImage (index, event) {
      this.form.files[index].filePaths = event;
      if (event.length) {
        this.form.files[index].inputValue = event.length;
      } else {
        this.form.files[index].inputValue = null;
      }
    },
    previousStep () {
      if (this.tradeType === '1') {
        let str = '';
        if (this.id && this.oldId) {
          str = '?id=' + this.id + '&oldId=' + this.oldId;
        } else if (this.id) {
          str = '?id=' + this.id;
        } else {
          str = '?oldId=' + this.oldId;
        }
        str += '&tradeType=' + this.tradeType + '&projectType=' + this.projectType + '&projectSubType=' + this.projectSubType;
        this.$router.replace('/publish-project/transferee-info' + str);
      } else {
        let str = '';
        if (this.id && this.oldId) {
          str = '?id=' + this.id + '&oldId=' + this.oldId;
        } else if (this.id) {
          str = '?id=' + this.id;
        } else {
          str = '?oldId=' + this.oldId;
        }
        this.$router.replace('/publish-project/project-info' + str);
      }
    },
    next() {
      this.$refs['attachmentForm'].validate(valid => {
        if (valid) {
          const files = [];
          this.form.files.forEach(item => {
            const filePaths = [];
            item.filePaths.forEach(obj => {
              filePaths.push(obj.sourceImgUrl);
            });
            files.push({
              imgEnumType: item.projectFileType,
              urls: [...filePaths]
            });
          });
          this.saveOrUpdateAttachmentInfo(files);
          // if (this.isCreated) {
          //   this.saveAttachmentInfo(files);
          // } else {
          //   this.updateAttachmentInfo(files);
          // }
        } else {
          return false;
        }
      });
    },
    // 保存或者更新
    saveOrUpdateAttachmentInfo (files) {
      let interfaceName = PublishProjectService.saveAttachmentInfo;
      if (!this.isCreated) {
        interfaceName = PublishProjectService.updateAttachmentInfo;
      }
      interfaceName({
        projectId: this.id,
        files: files
      }).then(res => {
        if (res && res.code === '0') {
          if(Number(this.tradeType) === 2) {
            this.$router.push('/publish-project/commitment-text?tradeType=' + this.tradeType + '&id=' + this.id + '&projectType=' + this.projectType);
          } else {
            if (this.oldId) {
              this.$router.push('/publish-project/commitment-info?id=' + this.id + '&oldId=' + this.oldId + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType );
            } else {
              this.$router.push('/publish-project/commitment-info?id=' + this.id + '&' + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType);
            }
          }
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存附件信息失败');
        }
      });
    },
    saveAttachmentInfo (files) {
      PublishProjectService.saveAttachmentInfo({
        projectId: this.id,
        files: files
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push('/publish-project/commitment-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType );
          } else {
            this.$router.push('/publish-project/commitment-info?id=' + this.id + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType);
          }
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('保存附件信息失败');
        }
      });
    },
    updateAttachmentInfo (files) {
      PublishProjectService.updateAttachmentInfo({
        projectId: this.id,
        files: files
      }).then(res => {
        if (res && res.code === '0') {
          if (this.oldId) {
            this.$router.push('/publish-project/commitment-info?id=' + this.id + '&oldId=' + this.oldId + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType );
          } else {
            this.$router.push('/publish-project/commitment-info?id=' + this.id + '&tradeType=' + this.tradeType + '&projectType=' + this.projectType  + '&projectSubType=' + this.projectSubType);
          }
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('更新附件信息失败');
        }
      });
    },
    // 下载模版
    downTemplate(type) {
      if(type === 1) {
        window.open('/资产资源权属证明模板.pdf');
      } else {
        window.open('/关于同意资产再流转的意见.pdf');
      }
    }
  }
};
